import { CheckOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    confirmButtonText?: string;
};

const DeclarationSubmittedModal = ({ open, onClose, onConfirm, confirmButtonText = 'Back to job' }: Props) => {
    return (
        <ConfirmationModal
            type="success"
            open={open}
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onConfirm}
            title="Declaration Submitted"
            confirmButtonText={confirmButtonText}
            icon={<CheckOutlined />}
            content={
                <>
                    <Typography.Text>The Declaration has been successfully submitted to Revenue.</Typography.Text>
                </>
            }
        />
    );
};

export default DeclarationSubmittedModal;
